/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bs-grid';
import BodyClassName from 'react-body-classname';
import Helmet from 'react-helmet';
import WindowSize from 'react-window-size';
// import { Element, scroller } from 'react-scroll';
// import Waypoint from 'react-waypoint';
import { palette as generatePalette, schemes } from '@potion/color';

import Page from '../components/Page';
import Space from '../components/Space';
// import Footer from '../components/Footer';
import LandingBg from '../components/Stream';
// import ShowMenuMixin from '../mixins/ShowMenuMixin';
// import { COLORS } from '../../constants';

// import Features from './Build/Features';
// import Navbar from './Build/Navbar';
// import Links from './Build/Links';
// import Shapes from './Build/Shapes';
// import Layouts from './Build/Layouts';
// import Extras from './Build/Extras';

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleTogglePalette = this.handleTogglePalette.bind(this);
  }
  // displayName: 'Build',

  // state: {
  //   renderCharts: false,
  //   activeSection: null,
  // },

  // componentDidMount() {
  //   if (this.props.match.params.section) this.handleScroll(this.props.match.params.section);
  //   this.interval = setInterval(() => {
  //     this.setState({ rerender: Math.random() });
  //   }, 5000);
  // },

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.match.params.section && nextProps.match.params.section !== this.props.match.params.section) {
  //     this.handleScroll(nextProps.match.params.section);
  //   }
  // },

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // },

  // handleScroll(target) {
  //   scroller.scrollTo(target, {
  //     duration: 800,
  //     delay: 100,
  //     smooth: true,
  //     offset: -110,
  //   });
  // },

  // getSideLength(columnCount = 3) {
  //   const { windowWidth } = this.props;
  //   switch (columnCount) {
  //     case 3: {
  //       let sideLength = 340;
  //       if (windowWidth < 1200) sideLength = 270;
  //       if (windowWidth < 992) sideLength = 210;
  //       if (windowWidth < 768) sideLength = 258;
  //       if (windowWidth < 570) sideLength = windowWidth - 100;
  //       if (windowWidth === 0) sideLength = 340;
  //       return sideLength;
  //     }
  //     case 2: {
  //       let sideLength = 440;
  //       if (windowWidth < 1200) sideLength = 330;
  //       if (windowWidth < 768) sideLength = 288;
  //       if (windowWidth < 570) sideLength = windowWidth - 100;
  //       if (windowWidth === 0) sideLength = 340;
  //       return sideLength;
  //     }
  //   }
  // },

  handleTogglePalette(id) {
    return (event) => {
      event.stopPropagation();
      this.setState({ toggledPalette: this.state.toggledPalette === id ? null : id }, () => {
        Prism.highlightAll();
      });
    };
  }

  renderPalette(id, config) {
    const palette = generatePalette(config);
    const count = 9;
    const rows = [];
    for (let i = count; i > 2; i--) {
      rows.push(palette(i));
    }
    return (
      <Col md={6} sm={12} xs={12} lg={4}>
        <a onClick={this.handleTogglePalette(id)}>
          {
            this.state.toggledPalette === id ? (
              <div>
                <pre className="language-javascript">
                  <code className="language-javascript">
                    {`import { palette } from '@potion/color';
const myPalette = palette(${JSON.stringify(config, null, 2)});
myPalette(colorCount);`}
                  </code>
                </pre>
              </div>
            ) :
              (<div className="palette">
                {rows.map((row, r) => (
                  <div className="palette__row" key={r}>
                    {row.map(background => (
                      <div style={{ background }} key={background} />
                    ))}
                  </div>
                ))}
              </div>)
          }
        </a>
      </Col>
    );
  }

  render() {
    const { windowWidth, windowHeight } = this.props;
    // const sideLengthThree = this.getSideLength();
    // const sideLengthTwo = this.getSideLength(2);
    return (
      <BodyClassName className={'no-padding'}>
        <Page
          fluid
          name="page-landing page-docs page-color"
          onClick={() => {
            this.setState({ toggledPalette: null });
          }}
        >
          <Helmet
            title="Potion.js - React + D3"
            meta={[
              {
                property: 'og:url',
                content: 'http://numberpicture.com/build',
              },
              {
                property: 'og:title',
                content: 'Potion.js - React + D3',
              },
              {
                property: 'og:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                name: 'twitter:title',
                content: 'Potion.js - React + D3',
              },
              {
                name: 'twitter:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                charSet: 'utf-8',
              },
            ]}
          />

          <Container fluid className="above-fold">

            {/* <LandingBg
              width={windowWidth}
              height={windowHeight}
              className="landing-bg"
              transform={{ rotate: [180, windowWidth / 2, windowHeight / 2] }}
            /> */}

            <Space className="hidden-xs" />

            <Row>
              <Col lg={6} offsetLg={3} md={8} offsetMd={2}>
                <h1>Potion Color</h1>
                <h2>Utilities for creating dynamic color palettes specifically for visualizing data.</h2>
                {/* <Link to="/docs" className="btn btn-primary btn-lg">Get Started</Link> */}
                {/* <Space /> */}
              </Col>
            </Row>
          </Container>

          <Container fluid>
            <Row className="content">
              <Container>
                <h2>Sequential</h2>
              </Container>
              {schemes.sequential.map(scheme => this.renderPalette(scheme, { scheme }))}

              <Space half />
              <Container>
                <h2>Custom</h2>
              </Container>
              {[
                ['#11998e', '#38ef7d'],
                ['#3F5EFB', '#FC466B'],
                ['#7F00FF', '#fdbb2d'],
                ['#e23403', '#f7b733'],
                ['#021B79', '#0575E6'],
                ['#0f3443', '#34e89e'],
                ['#03001e', '#ec38bc'],
                ['#636363', '#f7ff00'],
                ['#4b134f', '#c94b4b'],
              ].map(colors => this.renderPalette(`${colors[0]}_${colors[0]}`, { colors }))}

              <Space half />
              <Container>
                <h2>Diverging</h2>
              </Container>
              {schemes.diverging.map(scheme => this.renderPalette(scheme, { scheme }))}

              <Space half />
              <Container>
                <h2>Categorical</h2>
              </Container>
              {schemes.categorical.map(scheme => this.renderPalette(scheme, { scheme }))}

            </Row>

            <Space />
            <Space />

          </Container>
        </Page>
      </BodyClassName>
    );
  }
}

export default WindowSize(Landing);




// WEBPACK FOOTER //
// ./src/pages/color.js